import { render, staticRenderFns } from "./BundleSchedules.vue?vue&type=template&id=741af224&"
import script from "./BundleSchedules.vue?vue&type=script&lang=js&"
export * from "./BundleSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports